import React, {useState} from 'react'
import PropTypes from "prop-types";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import {
    cuadroRequerimientosRegistrarCampanaAPI,
} from "../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import Campana from "./Campana";
import {CAMPANA_KEYS} from "./campanaKeys";

const RegistrarCampana = ({toggleModal, refreshPage}) => {
    const SECTION_NAME = "RegistrarCampana"
    const [formValuesCampana, setFormValuesCampana] = useState({});

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();

    const handleSubmitRegistrar = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = cuadroRequerimientosRegistrarCampanaAPI();
        payload = getPayload();
        keys = CAMPANA_KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitRegistrarCallback, true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const getPayload = () => {
        return {
            ...formValuesCampana,
        }
    }

    const successSubmitRegistrarCallback = async ({data}) => {
        toggleModal();
        await refreshPage();
    }


    return (
        <ModalForm
            titulo="Nueva Campaña"
            width="800px"
            showModal={toggleModal}
            isSubmitting={isSubmitting}
            saveButtonDisabled={isSubmitting}
            onSubmit={handleSubmitRegistrar}>

            <div className="displayFlexWrap">
                <Campana
                    formValuesCampana={formValuesCampana}
                    setFormValuesCampana={setFormValuesCampana}
                    isCreate={true}
                    isEditable={true}
                    SECTION_NAME={SECTION_NAME}
                />
            </div>
        </ModalForm>
    );
}

RegistrarCampana.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default RegistrarCampana;